/**
 * The lottery-live strip — `design_handoff_order_and_lottery` §3, "Announcement elsewhere".
 *
 * THE THIRD BAR, AND THE SAME BAR. `.dstrip` again, for the reason `CommitteeStrip.tsx` gives:
 * this app has taught ten managers that a dark bar above the nav with a pulsing dot and one
 * button means something is running and here is the way in. A third grammar for the third live
 * event would make them learn it a third time.
 *
 * WHAT IT CARRIES THAT THE OTHERS DO NOT is the viewer's own result. Every other line on this bar
 * is on the board he is being invited to go and look at; "You choose 5th of 10" is the one thing
 * the draw is about to tell him, and once it has landed it is the only thing on the bar he
 * actually needs.
 */

import { managerShort } from '../domain/identity.js';
import { lotterySaid, type LotteryInfo } from '../domain/lotteryStrip.js';
import { GmBadge } from './GmBadge.js';
import { dockWhen } from './dock.js';
import { STRIP_FIXED, useMedia } from './useMedia.js';

export function LotteryStrip({ info, onGo }: { info: LotteryInfo; onGo: () => void }) {
  const fixed = useMedia(STRIP_FIXED);
  if (!info.live) return null;

  const mine = info.mine !== null;

  return dockWhen(fixed,
    <div className={`dstrip lottery ${mine ? 'landed' : ''}`} role="status">
      <span className="tag">
        <span className="dot" aria-hidden="true" />
        LOTTERY LIVE
      </span>

      <span className="said">
        <span className="wide">{lotterySaid(info)}</span>
        <span className="narrow">{lotterySaid(info, true)}</span>
      </span>

      {/* Whose name it was, while it is still somebody else's. Once the viewer's own has landed
          the sentence is about him and a second man's face beside it is a distraction. */}
      {!mine && info.gm && (
        <span className="gmwho">
          <GmBadge gm={info.gm} />
          <b>{managerShort(info.gm)}</b>
        </span>
      )}

      <span className="act">
        <span className="clock">{info.drawn} of {info.teams}</span>
        <button type="button" className="go" onClick={onGo}>
          <span className="wide">Watch the draw</span>
          <span className="narrow">Watch</span>
        </button>
      </span>
    </div>,
  );
}
